// src/services/devicegroupService.ts
import { DeviceGroupCreateRequest, DeviceGroupListQuery, DeviceGroupUpdateRequest } from "@/interface/requests/devicegroupRequest";
import { api, qs } from "./clientService";
import { DeviceGroup, DeviceGroupCreateResponse, DeviceGroupDetailResponse, DeviceGroupListResponse, DeviceGroupUpdateResponse } from "@/interface/responses/devicegroupResponse";


/** POST /api/v1/groups/create */
export function createDeviceGroup(payload: DeviceGroupCreateRequest) {
  // API returns 201 Created with the created group object
  return api<DeviceGroupCreateResponse>("/api/v1/groups/create", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

/** GET /api/v1/groups/list */
export function listDeviceGroups(query: DeviceGroupListQuery = {}) {
  return api<DeviceGroupListResponse>("/api/v1/groups/list" + qs(query), {
    method: "GET",
  });
}

/** GET /api/v1/groups/all*/
export function getAllDeviceGroups() {
  return api<DeviceGroup[]>("/api/v1/groups/all", {
    method: "GET",
  });
}

/** GET /api/v1/groups/{id} */
export function getDeviceGroupById(id: number) {
  return api<DeviceGroupDetailResponse>(`/api/v1/groups/${id}`, {
    method: "GET",
  });
}

/** PATCH /api/v1/groups/{id} */
export function updateDeviceGroup(id: number, payload: DeviceGroupUpdateRequest) {
  return api<DeviceGroupUpdateResponse>(`/api/v1/groups/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

/** DELETE /api/v1/groups/{id}
 * API docs show 200 OK with no body. Our client returns `null`/`void` for empty payloads.
 */
export function deleteDeviceGroup(id: number) {
  return api<void>(`/api/v1/groups/${id}`, { method: "DELETE" });
}